export enum QuoteOption {
  ShowAll,
  With,
  Without,
}
